import { BLACK } from '../colors';
var collapsibleConfig = {
  titleComponent: null,
  theme: 'light',
  version: 'variable-width',
  initialOpen: false,
  showIcon: true,
  iconColor: BLACK,
  iconSize: 'md',
  config: {
    size: {
      sm: {
        iconSize: 18
      },
      md: {
        iconSize: 20
      },
      lg: {
        iconSize: 22
      },
      xl: {
        iconSize: 24
      }
    }
  }
};
export default {
  light: collapsibleConfig,
  dark: collapsibleConfig,
  white: collapsibleConfig
};